import { supportedLanguages } from './i18n.config.json';

export const SUPPORTED_APP_LANGUAGES = Object.keys(supportedLanguages) as ReadonlyArray<
  keyof typeof supportedLanguages
>;

export const NATIONAL_ID_REGEX = {
  ['SA' as string]: /^[12][0-9]{9}$/,
};
export const COUNTRIES_WITH_NATIONAL_ID = Object.keys(NATIONAL_ID_REGEX);

export type LocaleCode = (typeof SUPPORTED_APP_LANGUAGES)[number];
export const RTL_LANGUAGES = ['ar'] as const;
export const BATCH_COUNT_BY_EXPERIENCE_TYPE = Object.freeze({
  job: 6,
  education: 4,
  hobby: 3,
});
// number of skills inside a batch in the legacy skill assessment
export const BATCH_SIZE = 10;
// rough estimate of how many skills are required to complete an experience, times the batch count
// used in case the experience doesn't have a recommended_skill_points value
export const ASSESSMENT_FALLBACK_REQUIRED_POINTS = 4;
export const TERMS_OF_USE_UPDATE_DATE = '2024-05-01';

export const REQUIRED_FIELD_MARKER = '*';

export const EMPTY_PLACEHOLDER = '—';
